import React from "react";
import { Oval } from "react-loader-spinner";

function Loader() {
  return (
    <div className="loader-container">
      <Oval
        visible={true}
        height="50"
        width="50" // add props width here
        color="#555555" 
        secondaryColor="#888888" 
        strokeWidth={5} 
        ariaLabel="oval-loading"
        wrapperStyle={{}}
        wrapperClass="loader"
      />
    </div>
  );
}

export default Loader;
